export const transformUsers = (usuarios) => {
	if (!usuarios || usuarios.length === 0) return [];
	return usuarios.map((item) => ({
		...item,
		perfil: item.organos.length === 0 ? 'Sin Perfil' : item.organos[0].perfilNombre,
		email: item.correos?.length > 0 ? item.correos[0]?.correo : '',
		cargo:
			item.cargo === 'PR' ? 'Propietario' : item.cargo === 'SU' ? 'Suplente' : '',
		FullLinkName: `${item.nombre} ${item.apellidoPaterno} ${item.apellidoMaterno}`,
		seccion:
			item.sector === 'SG'
				? 'Sector Gobierno'
				: item.sector === 'ST'
				? 'Sector Trabajador'
				: item.sector === 'SE'
				? 'Sector Empresarial'
				: '',
		organos:
			item.organos.length > 0 && item.miembro === true
				? [
						...new Set(
							item.organos.map(
								(o) =>
									` ${o.nombre} / ${
										o.cargo === 'PR'
											? 'Propietario'
											: o.cargo === 'SU'
											? 'Suplente'
											: ''
									}`
							)
						),
				  ].toString()
				: item.organos.length > 0 && item.miembro === false
				? [...new Set(item.organos.map((o) => ` ${o.nombre}`))].toString()
				: '',
	}));
};
